@let product = loadedProduct();
@if (product) {
  <div class="row gy-3" >
    @for (attribute of product.selectableAttributes | mapvalues; track attribute) {
      @if (getOptionDisplayMode(attribute); as displayMode) {
        @if ((attribute.options.length > 1 || attribute.code == 'leiste' || (displayMode == 'swatch'))) {
          <div class="col-12" [class.invalid]="validating()">
            <div class="attribute-selector {{ attribute.code }}" [class.error]="! isAttributeValid(attribute.code)">
              <!-- title -->
              <h4 aria-level="2">{{ attribute.title }}</h4>
              <!-- options -->
              @for (option of attribute.options; track option) {
                @if (isOptionVisible(option, attribute, displayMode)) {
                  <!-- swatch -->
                  @if ((displayMode == 'swatch' && option.imageSlug)) {
                    <div class="swatch-wrap">
                      <!-- swatch tooltip may show shop action in a special way -->
                      @let shopAction = getAttributeOptionAction(attribute, option);
                      <span class="swatch-color bold"
                        [ngbTooltip]="getTooltip(attribute, option)" placement="bottom-left"
                        [triggers]="screenService.currentDimensionIsSmallerThan('sm') ? 'manual' : 'hover focus'" #t1="ngbTooltip" (click)="t1.open()"
                        [class.disabled]="!isSelectionPossible(attribute.code, option) || !isSelectionInStockOrReminder(attribute.code, option)"
                        [attr.aria-disabled]="(!isSelectionPossible(attribute.code, option) || !isSelectionInStockOrReminder(attribute.code, option)) ? 'true' : null"
                        [class.selected]="isSelected(attribute.code, option)"
                        (click)="toggleActiveSelection(attribute.code, option)"
                        >
                        <img
                          [ngSrc]="option.imageSlug"
                          [attr.alt]="getTooltip(attribute, option)"
                          class="img-fluid img-round"
                          ngSrcset="18w, 32w"
                          width="30"
                          height="30"
                          />
                      </span>
                      @if (shopAction) {
                        <gea-svg-event-stars [size]="20"
                          [ngbTooltip]="'Aktion ' + shopAction.name" placement="bottom-left"
                        ></gea-svg-event-stars>
                      }
                    </div>
                  } @else {
                    <div [ngbTooltip]="getTooltip(attribute, option) ? optionToolTip : null" placement="bottom-left"
                      [triggers]="screenService.currentDimensionIsSmallerThan('sm') ? 'manual' : 'hover focus'" #t2="ngbTooltip" (click)="t2.open()"
                      [class.disabled]="!isSelectionPossible(attribute.code, option) || !isSelectionInStockOrReminder(attribute.code, option)"
                      [attr.aria-disabled]="(!isSelectionPossible(attribute.code, option) || !isSelectionInStockOrReminder(attribute.code, option)) ? 'true' : null"
                      [class.selected]="isSelected(attribute.code, option)"
                      (click)="toggleActiveSelection(attribute.code, option)"
                      class="tile">
                      {{ option.title }}{{ attribute.unit ? (' ' + attribute.unit) : '' }}
                    </div>
                    <ng-template #optionToolTip>
                      <div class="tile-tooltip"
                        [class.disabled]="!isSelectionPossible(attribute.code, option) || !isSelectionInStockOrReminder(attribute.code, option)">
                        @if (attribute.code == 'leiste') {
                          <gea-svg-shoe-width></gea-svg-shoe-width>
                        }
                        <span>{{ getTooltip(attribute, option) }}</span>
                      </div>
                    </ng-template>
                  }
                  <!-- text -->
                }
              }
              <!-- options end -->
            </div>
          </div>
        }
      }
    }
    @if (currentVariant?.variablePrice) {
      <h4 aria-level="2" for="variablePrice" class="form-label">Variabler Betrag</h4>
      <div class="col-12">
        @if (form) {
          <form novalidate autocomplete="off" [formGroup]="form">
            <div class="input-group variable-price mb-3">
              <input type="number" min="1" max="10000" step="0.01" class="form-control" formControlName="variablePrice" placeholder="125,00" (keyup)="changePrice()">
              <span class="input-group-text">€</span>
            </div>
          </form>
        }
      </div>
    }
    @if (showSizeGuide()) {
      <a role="button" class="text-decoration-underline" (click)="openSizeInfo()">
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 12.668C1 12.668 5 4.66797 12 4.66797C19 4.66797 23 12.668 23 12.668C23 12.668 19 20.668 12 20.668C5 20.668 1 12.668 1 12.668Z" stroke="#767472" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 15.668C13.6569 15.668 15 14.3248 15 12.668C15 11.0111 13.6569 9.66797 12 9.66797C10.3431 9.66797 9 11.0111 9 12.668C9 14.3248 10.3431 15.668 12 15.668Z" stroke="#767472" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Größen- und Weiteninformationen
      </a>
    }
  </div>
}
